export default "__VITE_ASSET__Vx3ifyJc__"